import React, { useState } from "react";
import "./CartItem.scss"
import Cart from "services/store/Cart";

const CartItem = ({product, token, onRemove, afterRemove}) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const removeItems = async () => {
        setIsDeleting(true);
        try {
            if (onRemove) {
                await onRemove();
            }

            await Cart.removeItem(product, token);

            if (afterRemove) {
                await afterRemove();
            }
        } catch (error) {
            console.error('Erreur lors de la suppression:', error);
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className="cart-item" key={product.id}>
            <div className="cart-itemDescription">
                <img alt={product.name} className="cart-itemImage" src={product?.product?.pictures[0]?.filename} />
                <div >
                    <div className="cart-itemText">{product.fullName} - {product.sellPriceMinimumDisplay}</div>
                    <div className="cart-itemText">{product.quantityDisplay}</div>
                </div>
            </div>
            <div className="cart-itemTotalTrash">
                <div className="cart-itemTotal">{product.totalPriceDisplay}</div>
                <button 
                    type="button" 
                    className="cart-trash" 
                    onClick={removeItems}
                    disabled={isDeleting}
                >
                    {isDeleting ? (
                        <i className="fas fa-spinner fa-spin"></i>
                    ) : (
                        <i className="fas fa-trash-alt"></i>
                    )}
                </button>
            </div>
        </div>
    )
};

export default CartItem;
